// This file is required to be in the root and titled index.js
// https://docs.expo.dev/build-reference/migrating/#custom--main--entry-point-in
import { registerRootComponent } from 'expo'

import App from './src/App'

registerRootComponent(App)
